<!--  -->
<template>
  <div class="child-box">
    <div class="child-head">
      <div class="child-name">环境检测</div>
    </div>
    <div class="content">
      <div class="content-item" v-for="(item,i) in baseData" :key="i">
        <div class="parmameter">{{item.parmameter}}</div>
        <div class="name">{{item.name}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      baseData: [
        {
          name: "风速",
          parmameter: "15.7m/s"
        },
        {
          name: "湿度",
          parmameter: "49%"
        },
        {
          name: "风向",
          parmameter: "东15"
        },
        {
          name: "扬尘",
          parmameter: "15mg/s"
        },
        {
          name: "温度",
          parmameter: "19"
        },
        {
          name: "能见度",
          parmameter: "15.7m/s"
        }
      ]
    };
  },

  components: {},

  computed: {},

  methods: {}
};
</script>
<style lang="less" scoped>
.content {
  width: 84%;
  height: 75%;
  margin-top: 7%;
  // background: red;
  margin-left: 8%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .content-item {
    width: 108px;
    height: 66px;
    background: url(../assets/hjbox.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    color: #bcdeff;
    font-size: 12px;
    .parmameter {
      height: 30px;
      text-align: center;
      margin-top: 5px;
    }
    .name {
      text-align: center;
    }
  }
}
</style>